export default {
      id: "facebook-round-24-usage",
      viewBox: "0 0 35 35",
      url: __webpack_public_path__ + "assets/iconset.svg#facebook-round-24",
      toString: function () {
        return this.url;
      }
    }